var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('k-video-grid',{attrs:{"items":_vm.sorted,"storage-key":"multiview","max-entries":100},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('item',{attrs:{"data":item,"timestamp":_vm.ts}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }